import { MixpanelEventSource, MixpanelSourceProvider, TabBar } from '@talos/kyoko';
import { useCallback } from 'react';
import { matchRoutes, useLocation, useNavigate } from 'react-router-dom';
import { useOrderFormToggle } from '../../hooks/useOrderFormToggle';
import type { NavigationItem } from '../../tokens/navigationPaths';

/**
 * Bottom tab bar for the trading section. Uses `matchRoutes` against `tradingNavItems` so the currently
 * matched top-level destination drives the bar's highlighted item and its sub-tab bar (if any).
 */
export function MobileNavigationTabBar({
  navItems,
  layoutSectionLabel,
}: {
  navItems: NavigationItem[];
  layoutSectionLabel: string;
}) {
  const location = useLocation();
  const navigate = useNavigate();
  const matches = matchRoutes(navItems, location);
  const currentTopLevelRoute = matches?.at(0)?.route as NavigationItem | undefined;

  const toggleOrderForm = useOrderFormToggle();
  const handleOpenOMS = useCallback(() => {
    toggleOrderForm();
  }, [toggleOrderForm]);
  const handleNavigate = useCallback((path: string) => navigate(path), [navigate]);

  if (!currentTopLevelRoute) {
    return null;
  }

  return (
    <MixpanelSourceProvider value={MixpanelEventSource.MobileTabBar}>
      <TabBar
        items={navItems}
        currentRoute={currentTopLevelRoute}
        layoutSectionLabel={layoutSectionLabel}
        onTradePress={handleOpenOMS}
        onNavigate={handleNavigate}
      />
    </MixpanelSourceProvider>
  );
}
